// The single source of truth for Chinese terminology (see docs/unfathomable/glossary.md).
// Every card, character and rules term shown to players uses these names; the English
// originals are kept on each definition as `en` for cross-reference with the rulebooks.

export const kSkillCardZh: Record<string, string> = {
  "Coordinated Effort": "协同努力",
  "Nothing to Hide": "光明磊落",
  "Inspiring Speech": "鼓舞演说",
  "Shrivelling": "枯萎术",
  "Lesser Banishment": "次级驱逐",
  "Forced Learning": "强行领悟",
  "Watch and Learn": "察而知之",
  "Keen Insight": "敏锐洞察",
  "Preparation": "未雨绸缪",
  "Combat Training": "战斗训练",
  "Rampage": "狂暴",
  "Shrug It Off": "硬扛",
  "Persistence": "坚持不懈",
  "Determination": "决心",
  "True Grit": "钢铁意志",
  "Reinforcements": "援军",
  "Call to Action": "召唤爪牙",
  "Siren Song": "塞壬之歌",
  "Ransack": "洗劫",
  "Perform Rites": "举行仪式",
};

export const kMythosZh: Record<string, string> = {
  m500: "仪式协作", m501: "鼠患", m502: "鼓舞船员", m503: "污水倒灌", m504: "献祭深潜者",
  m505: "仪式支援", m506: "诡异幻象", m507: "失窃的仪式材料", m508: "船上失火", m509: "志愿军",
  m510: "异变", m511: "尸满为患", m512: "蒸馏器损坏", m513: "指控", m514: "煤舱起火",
  m515: "碰撞航线", m516: "船长晚宴", m517: "漂流渔船", m518: "协同突袭", m519: "犯罪活动",
  m520: "阶级矛盾", m521: "无政府个人主义者", m522: "人力排水", m523: "封锁舱口", m524: "放下小艇",
  m525: "深潜者蜂拥", m526: "深潜者佯攻", m527: "父神的恩宠", m528: "车钟故障", m529: "不安的梦",
  m530: "舱室进水", m531: "司炉罢工", m532: "对未知的恐惧", m533: "食物配给", m534: "坚守防线",
  m535: "哄抢粮仓", m536: "恐怖幻象", m537: "船体渗漏", m538: "催眠旋律", m539: "求救信号",
  m540: "临时燃料", m541: "身份危机", m542: "越狱", m543: "渗透者", m544: "感染",
  m545: "故障将至", m546: "一窝小猫", m547: "应得的甜点", m548: "弹药失踪", m549: "珠宝失窃",
  m550: "伊哈恩斯雷的呼唤", m551: "神秘救生艇", m552: "母神之怒", m553: "走失的父母", m554: "乘客落水",
  m555: "开启传送门", m556: "主动出击", m557: "权力归于人民", m558: "有毒的食物", m559: "乘客暴动",
  m600: "狩猎开始", m601: "血脉之系", m602: "不伤害原则", m603: "深海的记忆", m604: "历史重演",
  m605: "母神的馈赠", m606: "生命迹象", m607: "和平使者", m608: "失算", m609: "请出示船票",
};

export const kWaypointZh: Record<string, string> = {
  wreckedShip: "失事船只", desertedIsland: "荒岛", abandonedDepot: "废弃补给站", iceberg: "冰山",
  hurricane: "飓风", reef: "暗礁", shipwreckSurvivors: "海难幸存者", deepOneCity: "深潜者之城",
  rainstorm: "暴雨", maelstrom: "大漩涡", fogBank: "雾墙", rogueWave: "疯狗浪", rollingSeas: "翻涌之海",
  seaSmoke: "海雾", seaweedPatch: "海藻带", smoothSailing: "一帆风顺", deepOneAmbush: "深潜者伏击",
  calmWaters: "平静水域", roughWaters: "惊涛骇浪", stormySeas: "风暴之海",
};

export const kSpellZh: Record<string, string> = {
  cloudMemory: "蒙蔽记忆", callFriends: "呼朋引伴", plagueOfLocusts: "蝗灾", lureMonster: "引诱怪物",
  heal: "治愈", greaterBanishment: "大驱逐", voiceOfRa: "拉之声", summonBeastWithin: "唤醒内在之兽",
  summonFire: "召火术", revelationOfScript: "经文启示", raiseTheDead: "起死回生", callDownTheStorm: "召唤风暴",
  astralTravel: "星界旅行", alchemicalTransmutation: "炼金转化", foresee: "预见", fleshWard: "血肉护符",
  feedTheMind: "滋养心智", darkPact: "黑暗契约", conjuration: "召物术",
};

export const kItemZh: Record<string, string> = {
  fineClothes: "华服", treasuredMemento: "珍贵信物", binoculars: "双筒望远镜", mysticalText: "神秘典籍",
  medicineBall: "药球", jamTinGrenade: "果酱罐手雷", sixShooter: "六发左轮", shotgun: "霰弹枪",
  repeatingRifle: "连发步枪", pocketPistol: "袖珍手枪", kitchenKnife: "菜刀", plimsolls: "帆布鞋",
  starbuck: "猎犬星巴克", travelPharmacy: "旅行药箱", toolKit: "工具箱", elderSignAmulet: "旧印护符",
  speakingTrumpet: "传声筒", bookOfDagon: "大衮之书", almanac: "年鉴", luckyRing: "「幸运」戒指",
};

export const kItemTraitZh: Record<string, string> = {
  Garment: "服饰", Artifact: "神器", Tool: "工具", Tome: "典籍", Explosive: "爆炸物", Weapon: "武器", Creature: "生物",
};

export const kDamageZh: Record<string, string> = {
  sdInfluence: "结构损伤（影响）", sdLore: "结构损伤（学识）", sdObservation: "结构损伤（观察）",
  sdStrength: "结构损伤（力量）", sdWill: "结构损伤（意志）", sdAny: "结构损伤（任意）",
  floodedFoodStores: "粮仓进水", fuelLeak: "燃料泄漏", fleeingPassengers: "乘客逃散",
};

/** Character name / title / ability names. */
export const kCharacterZh: Record<string, { name: string; ability: string; reveal: string; feat: string }> = {
  arjun: { name: "阿尔琼·辛格", ability: "甲板长", reveal: "偏离航线", feat: "自我牺牲" },
  beatrice: { name: "比阿特丽斯·夏普", ability: "预测分析", reveal: "分而治之", feat: "完美数字" },
  edmund: { name: "埃德蒙·马洛里", ability: "幸运之子", reveal: "散布厄运", feat: "离奇好运" },
  ishmael: { name: "以实玛利·马什", ability: "大衮第一誓", reveal: "立下第二誓", feat: "深潜者血统" },
  jamie: { name: "杰米·斯内尔", ability: "快速拔枪", reveal: "火力倾泻", feat: "逮捕令" },
  jeanne: { name: "让娜·拉法热", ability: "应急修理", reveal: "破坏", feat: "全速前进" },
  keilani: { name: "凯拉尼·塔图普", ability: "经验丰富", reveal: "打击士气", feat: "非常规领袖" },
  samira: { name: "萨米拉·杜阿莱", ability: "拾荒者", reveal: "扒手", feat: "装备齐全" },
  svetlana: { name: "斯维特兰娜·格德罗伊茨", ability: "治愈之言", reveal: "医疗事故", feat: "医疗介入" },
  william: { name: "威廉·鲍莱格", ability: "秘术修习", reveal: "扰乱仪式", feat: "快速施法" },
};

/** Rules vocabulary (also rendered into docs/unfathomable/glossary.md). */
export const kTerms: { en: string; zh: string; note?: string }[] = [
  { en: "Unfathomable", zh: "深渊之中" },
  { en: "SS Atlantica", zh: "亚特兰蒂卡号" },
  { en: "Deep One", zh: "深潜者" },
  { en: "Mother Hydra", zh: "母神海德拉" },
  { en: "Father Dagon", zh: "父神大衮" },
  { en: "Monarch", zh: "君主", note: "母神海德拉与父神大衮的合称" },
  { en: "Monster", zh: "怪物", note: "君主与深潜者的合称" },
  { en: "the Deep", zh: "深渊" },
  { en: "Human (loyalty)", zh: "人类" },
  { en: "Hybrid", zh: "混血" },
  { en: "Cultist", zh: "邪教徒" },
  { en: "Traitor / Revealed traitor", zh: "叛徒 / 已公开的叛徒" },
  { en: "Reveal as a traitor", zh: "公开身份" },
  { en: "Loyalty card", zh: "忠诚卡" },
  { en: "Awakening phase", zh: "觉醒阶段" },
  { en: "Captain", zh: "船长" },
  { en: "Keeper of the Tome", zh: "典籍守护者" },
  { en: "Line of succession", zh: "继承顺位" },
  { en: "Fuel / Food / Sanity / Souls", zh: "燃料 / 食物 / 理智 / 灵魂" },
  { en: "Influence / Lore / Observation / Strength / Will / Treachery", zh: "影响 / 学识 / 观察 / 力量 / 意志 / 背叛" },
  { en: "Skill card / Skill set", zh: "技能卡 / 技能组" },
  { en: "Skill check", zh: "技能检定" },
  { en: "Supporting / Opposing skill", zh: "支持技能 / 反对技能" },
  { en: "Target number / Partial pass", zh: "目标值 / 部分通过" },
  { en: "Chaos deck", zh: "混沌牌堆" },
  { en: "Mythos card / Crisis", zh: "神话卡 / 危机" },
  { en: "Activation icon / Track icon", zh: "激活图标 / 轨道图标" },
  { en: "Travel track / Arrive", zh: "航迹 / 抵达" },
  { en: "Ritual track / Cast", zh: "仪式轨 / 施法" },
  { en: "Greater banishment spell", zh: "大驱逐咒" },
  { en: "Waypoint / Distance", zh: "航点 / 航程" },
  { en: "Spell / Item / Improvement", zh: "法术 / 物品 / 改进物品" },
  { en: "Feat", zh: "特技", note: "每局限用一次" },
  { en: "Reveal ability", zh: "叛变能力", note: "公开叛徒身份后才能使用的角色能力" },
  { en: "Damage / Structural Damage / Repair", zh: "损伤 / 结构损伤 / 修理" },
  { en: "Passenger / Risk / Rescue", zh: "乘客 / 冒险放置 / 救援" },
  { en: "Defeat / Attack / Spawn / Activate", zh: "击败 / 攻击 / 生成 / 激活" },
  { en: "Water / Deck / Interior space", zh: "水域 / 甲板 / 舱室" },
  { en: "Bridge / Chapel / Captain's Cabin / Cargo Hold / Galley / Boiler Room", zh: "舰桥 / 礼拜堂 / 船长室 / 货舱 / 厨房 / 锅炉房" },
  { en: "Sick Bay / Brig", zh: "医务室 / 禁闭室" },
  { en: "Receive Skills / Action / Mythos / Discard step", zh: "获得技能 / 行动 / 神话 / 弃牌步骤" },
  { en: "Hand limit", zh: "手牌上限" },
  { en: "Current player", zh: "当前玩家" },
];
